<template>
<div class="page" v-if="$store.getters['auth/isAllowed']('can_view_admin_panel')">
    <BackBtn />
    <BreadCrumbs :items="breadcrumbs" />
    <div class=" d-flex align-center pb-4 mb-4">
        <h1 class="font-lg">Управление баннерами</h1>
    </div>
    <UploadBanner
      class="mb-10"
      :uploadFile="previewBanner"
      @openModal="changeVisibleCreateModal(true)"
      @updateFile="updateFile"
    />

    <div class="d-flex banner_preview">
      <BannerPreview :uploadFile="currentBanner" class="w-100"/>
      <v-btn
        v-if="currentBanner.isUpload"
        icon
        color="error"
        @click="changeVisibleDeleteModal(true)">
        <v-icon>mdi-trash-can</v-icon>
      </v-btn>
    </div>

    <ModalCreateBanner
      :open-modal="openCreateModal"
      :uploadFile="previewBanner"
      @upload:file="updateFile"
      @closeModal="changeVisibleCreateModal(false)"
      @uploadBanner="uploadFile"
    />
    <ModalDeleteBanner
      :showDlgDelete="openDeleteModal"
      @closeModal="changeVisibleDeleteModal(false)"
      @acceptDelete="changeVisibleSuccessModal(true,true)"
    />
    <ModalSuccessDelete
      :showDlgDelete="openSuccessDeleteModal"
      @closeModal="changeVisibleSuccessModal(false)"
    />
    <ModalSuccessUpload
      :showDlgUpload="openSuccessUploadModal"
      @closeModal="changeVisibleSuccessUploadModal(true)"
    />
</div>
</template>

<script>
import UploadBanner from '@/components/admin-panel/UploadBanner.vue';
import BannerPreview from '@/components/admin-panel/BannerPreview.vue';
import ModalDeleteBanner from '@/components/admin-panel/Modal/ModalDeleteBanner.vue';
import ModalSuccessDelete from '@/components/admin-panel/Modal/ModalSuccessDelete.vue';
import ModalSuccessUpload from '@/components/admin-panel/Modal/ModalSuccessUpload.vue';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';
import ModalCreateBanner from '@/components/admin-panel/Modal/ModalCreateBanner.vue';

/**
 * Компонент: AdminPanelBanners
 * Описание:
 */
export default {
  name: 'AdminPanelBanners',

  components: {
    ModalSuccessUpload,
    ModalSuccessDelete,
    ModalDeleteBanner,
    ModalCreateBanner,
    BannerPreview,
    UploadBanner
  },

  props: {},

  data() {
    return {
      openCreateModal: false,
      openDeleteModal: false,
      openSuccessDeleteModal: false,
      openSuccessUploadModal: false,
      previewBanner: { isUpload: false, image: null, imageBase64: null },
    };
  },
  computed: {
    ...mapGetters({
      bannerLinks: 'users/admins/hasBannerLinks',
      user: 'auth/user',
    }),
    breadcrumbs() {
     return [
         { title: 'Админка', url: '/admin-panel' },
         { title: 'Управление баннерами', url: '' },
     ];
    },
    currentBanner() {
     return {
       isUpload: !!this.bannerLinks,
       image: this.bannerLinks ? this.bannerLinks : null,
     };
    },
  },

  watch: {},

  created() {
  },

  mounted() {
    this.getCurrentBanner();
  },

  beforeDestroy() {},

  methods: {
    ...mapActions({
      bannerLink: 'users/admins/bannerLink',
      uploadBanner: 'users/admins/uploadBanner',
      deleteBanner: 'users/admins/deleteBanner',
    }),
    changeVisibleCreateModal(val) {
      this.openCreateModal = val;
    },
    changeVisibleDeleteModal(val) {
      this.openDeleteModal = val;
    },
   async changeVisibleSuccessModal(val, close = false) {
      if (!this.$store.getters['auth/isAllowed']('can_view_admin_panel')) return;
      if (close) {
        this.changeVisibleDeleteModal(false);
      }
      const res = await this.deleteBanner();
      if (res) {
        this.previewBanner = { isUpload: false, image: null, imageBase64: null };
        this.getCurrentBanner();
        this.openSuccessDeleteModal = val;
      }
    },
    changeVisibleSuccessUploadModal(val, close = false) {
      if (close) {
        this.changeVisibleDeleteModal(false);
      }
      if (val) {
        this.openCreateModal = false;
        this.openSuccessUploadModal = false;
      } else {
        this.openCreateModal = false;
        this.openSuccessUploadModal = true;
      }
    },
    getCurrentBanner() {
      return this.bannerLink();
    },
    updateFile(file) {
      if (!file || !file.type.match('image.*')) {
        this.previewBanner.isUpload = false;
        this.previewBanner.image = null;
        return;
      }

      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSize) {
        return;
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        this.previewBanner.isUpload = true;

        this.previewBanner.image = file;
        this.previewBanner.imageBase64 = e.target.result;
      };

      reader.readAsDataURL(file);
    },
    async uploadFile(file) {
      if (!file) { return; }
      if (!this.$store.getters['auth/isAllowed']('can_view_admin_panel')) return;
      try {
        const res = await this.uploadBanner(file);
        if (res.has_banner) {
          this.changeVisibleSuccessUploadModal();
          this.getCurrentBanner();
          this.previewBanner = { isUpload: false, image: null, imageBase64: null };
        } else if (res.data && res.data.file) {
            Vue.prototype.$toast.error(res.data.file, '', { position: 'topRight' });
          }
      } catch (error) {
        return error;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.banner_preview{
  position: relative;
  width: 100%;
  & .v-btn{
  position: absolute;
    right: 15px;
    top: 15px;
    width: 40px;
    min-height: 40px;
    min-width: 40px;
    height: 40px;
    border: 1px solid var(--color-grey-500);
    border-radius: 100%;
    padding: 0!important;
  }
  & .v-icon{
    font-size: 20px;
  }
}
</style>
